// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__GNAiY","block":"faq_block__nUzZL"};